import { ComponentProps, forwardRef } from 'react';

import { cn } from '@/utils/styles';

import { Label } from './label';
import { Fieldset } from './fieldset';

type TextareaProps = ComponentProps<'textarea'> & {
  classNameFieldSet?: string;
  classNameLabel?: string;
  label?: string;
  name: string;
  errorMessage?: string;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    id,
    name,
    label,
    required,
    classNameFieldSet = '',
    classNameLabel = '',
    className = '',
    errorMessage,
    ...rest
  } = props;

  return (
    <Fieldset className={classNameFieldSet}>
      {label && (
        <Label htmlFor={id ?? name} required={required} className={classNameLabel}>
          {label}
        </Label>
      )}
      <textarea
        {...rest}
        ref={ref}
        data-slot="textarea"
        name={name}
        className={cn(
          'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
      />
      {errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}
    </Fieldset>
  );
});

Textarea.displayName = 'Textarea';
